import Cookie from 'common/services/util/-RFC.Cookie';
import { socketLogger as log } from 'common/services/logging/loggers';
import eventManager from 'common/services/-RFC.eventManager';
import whitelistedPaths from 'common/constants/pathWhitelist';
import Deferred from 'common/services/util/-RFC.deferred';

let receivedSessionId = window.sessionStorage.getItem('websocketsId') || null;

const MAX_RETRIES = 3;
const MULTIPLYING_FACTOR = 2;
let currentDelay = 1000;
let retryAttempts = 0;

function WebSocketService() {

    const WebSocketPromise = new Deferred();
    let connection = null;
    let isConnected = false;
    let pingInterval;

    const API = {
        connect,
        isConnected,
    };

    function connect() {

        // only attempt to connect, if there hasn't been an attempt to connect
        if (!connection) {

            connection = new WebSocket(CWCONFIG.socket.acnsUrl);

            connection.onopen = () => {

                const token = Cookie.get(CWCONFIG.cookie.token);

                const subscribePayload = {
                    acp: '1.0',
                    host: 'dashboard',
                    verb: 'SUBSCRIBE',
                    path: '/notifications',
                    id: receivedSessionId,
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                };

                connection.send(JSON.stringify(subscribePayload), (error) => {

                    if (error) {

                        log.error(error);

                    }

                });
                log.log({
                    type: 'SEND',
                    cmd: subscribePayload.path,
                    data: {
                        ...subscribePayload,
                    },
                });

                startPingInterval();

            };

            connection.onmessage = (event) => {

                // when we get a response to our request for subscription to websockets server
                // we resolve the promise, and set the ready property to true
                if (!isConnected) {

                    WebSocketPromise.resolve();
                    isConnected = true;

                }

                let message;
                const extraParams = {};
                if (event && typeof event.data === 'string') {

                    try {

                        message = JSON.parse(event.data);

                    } catch (error) {

                        log.error('Received data is not in JSON format', error);

                    }

                    // set the session id from the backend response
                    // used for subsequent requests, or when reconnecting
                    if (!receivedSessionId && message.headers && message.headers['X-Avira-Session']) {

                        receivedSessionId = message.headers && message.headers['X-Avira-Session'];
                        window.sessionStorage.setItem('websocketsId', receivedSessionId);

                    }

                    log.log({
                        type: 'RCV',
                        cmd: message.payload.path,
                        data: {
                            message,
                        },
                    });

                    // for REST responses broadcast an event which contains the path in its name
                    let eventToBroadcast;
                    if (message.payload.acp) {

                        eventToBroadcast = getResourceFromPath(message.payload.path);

                        if (eventToBroadcast) {

                            eventManager.broadcast(
                                `socket:${eventToBroadcast}`,
                                message.payload,
                                extraParams,
                            );

                        }

                    }

                }

            };

            connection.onerror = () => {

                WebSocketPromise.reject();
                WebSocketPromise.promise.catch(() => { });

                resetConnectionState();
                retryToConnect();

            };

            connection.onclose = () => {

                WebSocketPromise.reject();
                WebSocketPromise.promise.catch(() => { });

                resetConnectionState();
                retryToConnect();

            };

        }

        return WebSocketPromise.promise;

    }

    function retryToConnect() {

        if (retryAttempts < MAX_RETRIES) {

            retryAttempts += 1;

            return setTimeout(
                () => {

                    currentDelay *= MULTIPLYING_FACTOR;
                    return connect();

                },
                currentDelay,
            );

        }

        return true;

    }

    // https://stackoverflow.com/questions/729921/settimeout-or-setinterval
    // we use a recursive timeout because
    // Chained-Timeout gives a guaranteed slot of free time to the browser;
    // Interval tries to ensure the function it is running executes
    // as close as possible to its scheduled times,
    // at the expense of browser UI availability.
    function startPingInterval() {

        pingInterval = setTimeout(function ping() {

            const connectionIsInClosingState = connection &&
                (connection.readyState === 2 || connection.readyState === 3);

            if (connectionIsInClosingState) {

                resetConnectionState();
                connect();

            }
            pingInterval = setTimeout(ping, 30000);

        }, 30000);

    }

    function resetConnectionState() {

        connection = null;
        isConnected = false;
        clearTimeout(pingInterval);

    }


    return API;

}

/**
     * Extracts the resource name from a request/response path
     * For example, for the path:
     * '/v1/app-integrations?filter[to]=dashboard&include=from&lang=en'
     * the function will return 'app-integrations'
     * @param {string} path The message path
     * @return {string} The resource
     */
function getResourceFromPath(path) {

    let pieces;
    /* split the path and choose the piece which is found in cmds array */
    if (path) {

        pieces = path.split(/[/?&]/);
        return _.find(pieces, piece => _.contains(whitelistedPaths, piece));

    }

    return false;

}

export default new WebSocketService();



// WEBPACK FOOTER //
// ./scripts/common/services/webSockets.js